export default __webpack_public_path__ + "static/media/insight.20ead3c4.png";